import EditIcon from '@mui/icons-material/Edit';
import MilageInfo from 'components/MilageInfo';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect, useState } from 'react';
// import { useForm } from "hooks/useForm"
import { useAppSelector } from 'app/hooks';
import Button from 'blocks/Button';
import Form, { DatePicker, SelectField, TextField } from 'components/Form';
import { fillFields, resetFields } from 'helper/InputField';
import { getDate } from 'helper/date';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { isLTRState } from 'store/options/optionsSlice';
import ajax from 'utils/ajax';
import { NATIONALITY, TITLE_MENU } from 'utils/constants';
import urls from 'utils/urls';
import * as S from './Profile.styles';

import { Chip, Divider } from '@mui/material';
import axios from 'axios';
import Loading from 'components/Loading';
import dayjs from 'dayjs';
import { Maybe } from 'models/types';
import ModalVerifyCode from 'pages/signup/components/ModalVerifyCode';
import { useDispatch } from 'react-redux';
import { getUserService, updateUserService } from 'services/userInfo.service';
import {
  setUser,
  setUserInfo,
  setUserInfoError,
  setUserInfoLoading,
  userInfoState,
} from 'store/userInfo/userInfoSlice';
import { UserInterface } from 'store/userInfo/userInfoSlice.interface';
import { CodeTypes, ProfileFormModel } from './profile.interface';

// TODO: translate issue in file

const Profile = () => {
  const { t } = useTranslation();
  const isLTR = useAppSelector(isLTRState);
  const { register, handleSubmit, setValue, getValues, watch } = useForm<ProfileFormModel>();
  const [typeUserAll, setTypeUserAll] = useState<Array<CodeTypes>>([]);
  const [userCodeType, setUserCodeType] = useState<Array<CodeTypes>>([]);
  const [typeUser, setTypeUser] = useState<string>('');
  const [disabledInput, setDisabledInput] = useState<boolean>(true);
  const [disabledChangePassword, setDisabledChangePassword] = useState<boolean>(true);
  const [disabledMobileNumber, setDisabledMobileNumber] = useState<boolean>(true);
  const [disabledEmail, setDisabledEmail] = useState<boolean>(true);
  const [showModalVerifyCode, setShowModalVerifyCode] = useState(false);
  const [mobileVerifyLoading, setMobileVerifyLoading] = useState(false);
  const [activeUserInfoField, setActiveUserInfoField] = useState<Maybe<'mobile' | 'email'>>(null);
  const [loading, setLoading] = useState(true);
  const userInfo = useAppSelector(userInfoState);
  const dispatch = useDispatch();

  useEffect(() => {
    getUserData();
  }, []);

  const getUserData = () => {
    dispatch(setUserInfoLoading('userInfo'));
    getUserService()
      .then((res) => {
        dispatch(setUser(res.data));
      })
      .catch((err) => {
        dispatch(setUserInfoError({ type: 'userInfo', err }));
      });
  };

  useEffect(() => {
    if (userInfo.data) {
      setUserCodeType(userInfo.data.PassengerTypeCodes);

      fillInputs(userInfo.data);
    }
  }, [userInfo]);

  const fillInputs = (user: UserInterface): void => {
    setLoading(true);
    if (!user) return;

    const {
      enFname,
      enLname,
      nationality,
      birthdate,
      nationalId,
      address,
      personId,
      title,
      docId,
      docExpireDate,
      email,
      mobile,
      zipCode,
      passportIssuingCountry,
      Parent,
    } = user;
    setTypeUser(user.type);
    fillFields(
      {
        enFname,
        enLname,
        nationality,
        birthdate: getDate(birthdate, 'YYYY-MM-DD'),
        passportIssuingCountry,
        nationalId,
        address,
        personId,
        zipCode,
        title,
        docId,
        docExpireDate: getDate(docExpireDate, 'YYYY-MM-DD'),
        email,
        mobile,
        Parent,
      },
      setValue
    );
    setTimeout(() => {
      setLoading(false);
    }, 100);
  };

  const changePassword = async (dataForm: ProfileFormModel) => {
    const { password, reEnterPassword, newPassword } = dataForm;
    if (!reEnterPassword || !newPassword || reEnterPassword !== newPassword)
      return toast.error(t('pages.profile.sections.securityDetails.form.errors.notSamePasswords'));

    await ajax({
      url: urls.password,
      method: 'PATCH',
      data: {
        password,
        newPassword,
      },
      showNotif: true,
    });

    resetFields(['password', 'reEnterPassword', 'newPassword'], setValue);

    setDisabledChangePassword(true);
  };

  const updateUserInfo = async (dataForm: ProfileFormModel) => {
    const {
      enFname,
      enLname,
      docId,
      birthdate,
      title,
      nationality,
      docExpireDate,
      passportIssuingCountry,
      nationalId,
      fatherName,
      personId,
      zipCode,
      address,
    } = dataForm;

    const data = {
      // faFname: enFname,
      // faLname: enLname,
      // enFname,
      // enLname,
      docId,
      // birthdate,
      title,
      //  nationality,
      docExpireDate,
      passportIssuingCountry,
      nationalId,
      fatherName,
      personId,
      zipCode,
      address,
    };
    if (dataForm.nationality !== 'IR') {
      delete data.fatherName;

      delete data.personId;
    }
    // if (!data.enFname) {
    //   return toast.error('First name is empty');
    // } else if (!data.enLname) {
    //   toast.error('Last name is empty');
    // if (!data.birthdate) {
    //   toast.error('Date of birth is empty');
    // }
    // if (!data.nationality) {
    //   toast.error('Nationality is empty');
    // }
    if (!data.title) {
      toast.error('Title is empty');
    } else if (!data.docId) {
      toast.error('Passport No is empty');
    } else if (!data.passportIssuingCountry) {
      toast.error('Passport issuing country is empty');
    } else if (!data.docExpireDate) {
      toast.error('Passport Expiration Date is empty');
      // } else if (!data.nationalId) {
      //   toast.error('nationalId is empty');
    } else {
      dispatch(setUserInfoLoading('userInfo'));
      updateUserService(data)
        .then((res) => {
          dispatch(setUserInfo(res.data.response));
          fillInputs(res.data.response);
        })
        .catch((err) => {
          dispatch(setUserInfoError({ type: 'userInfo', err }));
          toast.error(err.response.data.message);
        });
      setDisabledInput(true);
    }
  };

  const updateEmailAndNumber = async (fieldType: 'mobile' | 'email') => {
    setActiveUserInfoField(fieldType);
    const payload =
      fieldType === 'mobile'
        ? { type: 'change-number', mobile: getValues('mobile') }
        : { type: 'change-email', email: getValues('email') };
    await axios
      .post(urls.sendCodeByType, payload)
      .then((res) => {
        setShowModalVerifyCode(true);
        toast.success(`code will be send to your new ${fieldType === 'mobile' ? 'mobile number' : 'email'}`);
      })
      .catch((ex) => {
        setDisabledMobileNumber(true);
        setDisabledEmail(true);
      });
  };

  const closeVerifyCodeModal = () => {
    setShowModalVerifyCode(false);
    setDisabledEmail(true);
    setDisabledMobileNumber(true);
  };

  const changePhone = async (code: string) => {
    setMobileVerifyLoading(true);
    await axios
      .patch(
        urls.changeNumber,

        {
          code,
          mobile: getValues('mobile'),
        }
      )
      .then((res) => {
        closeVerifyCodeModal();
        toast.success('Your Phone Number Has Been Updated');
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);
        closeVerifyCodeModal();
      })
      .finally(() => {
        setMobileVerifyLoading(false);
      });
  };
  const changeEmail = async (code: string) => {
    setMobileVerifyLoading(true);
    await axios
      .patch(urls.changeEmail, {
        code,
        email: getValues('email'),
      })
      .then((res) => {
        closeVerifyCodeModal();
        toast.success('Your Email Has Been Updated');
      })
      .catch((ex) => {})
      .finally(() => {
        setMobileVerifyLoading(false);
      });
  };

  return (
    <WithSidebar>
      {userInfo.loading || loading ? (
        <Loading />
      ) : (
        <S.Wrapper>
          <>
            <S.ProfileMilage as={MilageInfo} typeUser={typeUser} />

            <S.ProfileCard>
              <S.ProfileHead>
                <S.ProfileBoxTitle>{t('pages.profile.sections.personalDetails.title')}</S.ProfileBoxTitle>

                <div>
                  {disabledInput ? (
                    <S.ProfileCardBtnNbg
                      as={Button}
                      color="text-button"
                      iconStart={<EditIcon />}
                      onClick={() => setDisabledInput(false)}
                    >
                      {t('pages.profile.sections.personalDetails.editCTA')}
                    </S.ProfileCardBtnNbg>
                  ) : (
                    <S.ParentCancleAndDef>
                      <S.ProfileCardBtnCancleAuto as={Button} color="outlined" onClick={() => setDisabledInput(true)}>
                        {t('pages.profile.sections.personalDetails.form.cancelCTA')}
                      </S.ProfileCardBtnCancleAuto>
                      <S.ProfileCardBtndefult
                        as={Button}
                        styleType="default"
                        onClick={() => handleSubmit(updateUserInfo)()}
                      >
                        {t('pages.profile.sections.personalDetails.form.updateCTA')}
                      </S.ProfileCardBtndefult>
                    </S.ParentCancleAndDef>
                  )}
                </div>
              </S.ProfileHead>
              {!disabledInput ? (
                <S.FormAnnouncement>
                  {t('pages.profile.sections.personalDetails.form.formAnnouncement')}
                </S.FormAnnouncement>
              ) : null}
              <Form>
                <S.ProfileFormInputWrapper>
                  <S.TextFieldProfile
                    as={TextField}
                    control={register('enFname')}
                    label={t('pages.profile.sections.personalDetails.form.fields.firstName')}
                    disabled={true}
                    readonly={true}
                  />
                  <S.TextFieldProfile
                    as={TextField}
                    control={register('enLname')}
                    label={t('pages.profile.sections.personalDetails.form.fields.lastName')}
                    disabled={true}
                    readonly={true}
                  />
                  <S.TextFieldProfile
                    as={SelectField}
                    control={register('nationality')}
                    menu={NATIONALITY}
                    autoCompelete
                    label={t('pages.profile.sections.personalDetails.form.fields.nationality')}
                    onChange={(value: string) => setValue('nationality', value)}
                    disabled={true}
                    defaultValue={getValues('nationality')}
                  />

                  <DatePicker
                    dir={'ltr'}
                    disabled={true}
                    label={t('pages.profile.sections.personalDetails.form.fields.birthdate')}
                    defaultValue={getValues('birthdate')}
                    // onChange={(date: DayValue) =>
                    //   setValue('birthdate', dayValueToDate(date, 'YYYY-MM-DD', isLTR ? 'YYYY-MM-DD' : 'jYYYY-jMM-jDD'))
                    // }
                    onChange={(date) => setValue('birthdate', date)}
                  />
                  {watch('nationality') && getValues('nationality').toLocaleLowerCase() === 'ir' ? (
                    <>
                      <TextField
                        control={register('nationalId')}
                        label={t('pages.profile.sections.personalDetails.form.fields.nationalId')}
                        disabled={disabledInput}
                        readonly={true}
                      />
                      <TextField
                        control={register('fatherName')}
                        label={t('pages.profile.sections.personalDetails.form.fields.fatherName')}
                        disabled={disabledInput}
                      />

                      <TextField
                        control={register('personId')}
                        label={t('pages.profile.sections.personalDetails.form.fields.personId')}
                        disabled={disabledInput}
                      />
                    </>
                  ) : (
                    ''
                  )}
                  {typeUser === 'ADT' ? (
                    <>
                      <TextField
                        dir={'ltr'}
                        control={register('zipCode')}
                        label={t('pages.profile.sections.personalDetails.form.fields.zipCode')}
                        disabled={disabledInput}
                      />

                      <TextField
                        control={register('address')}
                        label={t('pages.profile.sections.personalDetails.form.fields.address')}
                        disabled={disabledInput}
                      />
                    </>
                  ) : (
                    ''
                  )}
                  <SelectField
                    control={register('title')}
                    disabled={disabledInput}
                    label={t('pages.profile.sections.personalDetails.form.fields.title')}
                    onChange={(value: string) => setValue('title', value)}
                    menu={TITLE_MENU}
                    defaultValue={getValues('title')}
                  />

                  <TextField
                    dir={'ltr'}
                    control={register('docId')}
                    label={t('pages.profile.sections.personalDetails.form.fields.passportNo')}
                    disabled={disabledInput}
                  />
                  <SelectField
                    control={register('passportIssuingCountry')}
                    label={t('pages.profile.sections.personalDetails.form.fields.passportCountry')}
                    onChange={(value: string) => setValue('passportIssuingCountry', value)}
                    disabled={disabledInput}
                    menu={NATIONALITY}
                    autoCompelete
                    defaultValue={getValues('passportIssuingCountry')}
                  />
                  <DatePicker
                    dir={'ltr'}
                    disabled={disabledInput}
                    label={t('pages.profile.sections.personalDetails.form.fields.passportExpiration')}
                    defaultValue={getValues('docExpireDate')}
                    onChange={(date) => setValue('docExpireDate', date)}
                  />
                </S.ProfileFormInputWrapper>
                <div style={{ margin: '1.5rem 0px' }}>
                  <Divider>{/* <Chip label="Chip" size="small" /> */}</Divider>
                  <S.ProfileFormInputWrapper>
                    <div style={{ padding: '1.5rem 8px ' }}>
                      <S.LabelAutocomplete>
                        {t('pages.profile.sections.personalDetails.form.fields.codeType')}
                      </S.LabelAutocomplete>
                      <S.UserCodeType>
                        {userCodeType.map((option, index) => (
                          <div>
                            <Chip label={option.code} />
                          </div>
                        ))}
                      </S.UserCodeType>
                    </div>
                  </S.ProfileFormInputWrapper>
                </div>
              </Form>
            </S.ProfileCard>
            {dayjs(getValues('birthdate')).isBefore(dayjs().add(-12, 'year').add(3, 'month')) && typeUser === 'CHD' ? (
              // (!getValues('email') || !getValues('mobile')) ? (
              <S.ProfileCard>
                <S.ProfileBoxTitleMargin>{t('pages.profile.sections.contactDetails.title')}</S.ProfileBoxTitleMargin>
                <S.UserInfoFormInputWrapper>
                  <S.ParntNumberInput>
                    <S.UserInfoField>
                      <TextField
                        dir={'ltr'}
                        control={register('email')}
                        label={t('pages.profile.sections.contactDetails.form.fields.email')}
                        readonly={disabledEmail}
                        disabled={disabledEmail}
                      />
                    </S.UserInfoField>
                    <S.ParentBtns>
                      {disabledEmail ? (
                        <S.ProfileCardBtnNbg
                          as={Button}
                          color="text-button"
                          iconStart={<EditIcon />}
                          onClick={() => setDisabledEmail(false)}
                        >
                          {t('pages.profile.sections.personalDetails.editCTA')}
                        </S.ProfileCardBtnNbg>
                      ) : (
                        <S.ParentCancleAndDef>
                          <S.ProfileCardBtnCancleAuto
                            as={Button}
                            color="outlined"
                            onClick={() => setDisabledEmail(true)}
                          >
                            {t('pages.profile.sections.personalDetails.form.cancelCTA')}
                          </S.ProfileCardBtnCancleAuto>
                          <S.ProfileCardBtndefult
                            as={Button}
                            styleType="default"
                            onClick={() => updateEmailAndNumber('email')}
                          >
                            {t('pages.profile.sections.personalDetails.form.updateCTA')}
                          </S.ProfileCardBtndefult>
                        </S.ParentCancleAndDef>
                      )}
                    </S.ParentBtns>
                  </S.ParntNumberInput>

                  <S.ParntNumberInput>
                    <S.UserInfoField>
                      <TextField
                        dir={'ltr'}
                        control={register('mobile')}
                        label={t('pages.profile.sections.contactDetails.form.fields.mobile')}
                        readonly={disabledMobileNumber}
                        disabled={disabledMobileNumber}
                      />
                    </S.UserInfoField>
                    <S.ParentBtns>
                      {disabledMobileNumber ? (
                        <S.ProfileCardBtnNbg
                          as={Button}
                          color="text-button"
                          iconStart={<EditIcon />}
                          onClick={() => setDisabledMobileNumber(false)}
                        >
                          {t('pages.profile.sections.personalDetails.editCTA')}
                        </S.ProfileCardBtnNbg>
                      ) : (
                        <S.ParentCancleAndDef>
                          <S.ProfileCardBtnCancleAuto
                            as={Button}
                            color="outlined"
                            onClick={() => setDisabledMobileNumber(true)}
                          >
                            {t('pages.profile.sections.personalDetails.form.cancelCTA')}
                          </S.ProfileCardBtnCancleAuto>
                          <S.ProfileCardBtndefult
                            as={Button}
                            styleType="default"
                            onClick={() => updateEmailAndNumber('mobile')}
                          >
                            {t('pages.profile.sections.personalDetails.form.updateCTA')}
                          </S.ProfileCardBtndefult>
                        </S.ParentCancleAndDef>
                      )}
                    </S.ParentBtns>
                  </S.ParntNumberInput>
                </S.UserInfoFormInputWrapper>
              </S.ProfileCard>
            ) : (
              ''
            )}
            {typeUser === 'ADT' ? (
              <S.ProfileCard>
                <S.ProfileBoxTitleMargin>{t('pages.profile.sections.contactDetails.title')}</S.ProfileBoxTitleMargin>
                <S.UserInfoFormInputWrapper>
                  <S.ParntNumberInput>
                    <S.UserInfoField>
                      <TextField
                        dir={'ltr'}
                        control={register('email')}
                        label={t('pages.profile.sections.contactDetails.form.fields.email')}
                        readonly={disabledEmail}
                        disabled={disabledEmail}
                      />
                    </S.UserInfoField>
                    <S.ParentBtns>
                      {disabledEmail ? (
                        <S.ProfileCardBtnNbg
                          as={Button}
                          color="text-button"
                          iconStart={<EditIcon />}
                          onClick={() => setDisabledEmail(false)}
                        >
                          {t('pages.profile.sections.personalDetails.editCTA')}
                        </S.ProfileCardBtnNbg>
                      ) : (
                        <S.ParentCancleAndDef>
                          <S.ProfileCardBtnCancleAuto
                            as={Button}
                            color="outlined"
                            onClick={() => setDisabledEmail(true)}
                          >
                            {t('pages.profile.sections.personalDetails.form.cancelCTA')}
                          </S.ProfileCardBtnCancleAuto>
                          <S.ProfileCardBtndefult
                            as={Button}
                            styleType="default"
                            onClick={() => updateEmailAndNumber('email')}
                          >
                            {t('pages.profile.sections.personalDetails.form.updateCTA')}
                          </S.ProfileCardBtndefult>
                        </S.ParentCancleAndDef>
                      )}
                    </S.ParentBtns>
                  </S.ParntNumberInput>

                  <S.ParntNumberInput>
                    <S.UserInfoField>
                      <TextField
                        dir={'ltr'}
                        control={register('mobile')}
                        label={t('pages.profile.sections.contactDetails.form.fields.mobile')}
                        readonly={disabledMobileNumber}
                        disabled={disabledMobileNumber}
                      />
                    </S.UserInfoField>
                    <S.ParentBtns>
                      {disabledMobileNumber ? (
                        <S.ProfileCardBtnNbg
                          as={Button}
                          color="text-button"
                          iconStart={<EditIcon />}
                          onClick={() => setDisabledMobileNumber(false)}
                        >
                          {t('pages.profile.sections.personalDetails.editCTA')}
                        </S.ProfileCardBtnNbg>
                      ) : (
                        <S.ParentCancleAndDef>
                          <S.ProfileCardBtnCancleAuto
                            as={Button}
                            color="outlined"
                            onClick={() => setDisabledMobileNumber(true)}
                          >
                            {t('pages.profile.sections.personalDetails.form.cancelCTA')}
                          </S.ProfileCardBtnCancleAuto>
                          <S.ProfileCardBtndefult
                            as={Button}
                            styleType="default"
                            onClick={() => updateEmailAndNumber('mobile')}
                          >
                            {t('pages.profile.sections.personalDetails.form.updateCTA')}
                          </S.ProfileCardBtndefult>
                        </S.ParentCancleAndDef>
                      )}
                    </S.ParentBtns>
                  </S.ParntNumberInput>
                </S.UserInfoFormInputWrapper>
              </S.ProfileCard>
            ) : (
              <S.ProfileCard>
                <S.ProfileHead>
                  <S.ProfileBoxTitleMargin>
                    {t('pages.profile.sections.ParentInformation.title')}
                  </S.ProfileBoxTitleMargin>
                </S.ProfileHead>

                <S.PasswordFormInputWrapper>
                  <TextField
                    control={register('Parent.enFname')}
                    label={t('pages.profile.sections.ParentInformation.form.fields.firstName')}
                    disabled={true}
                  />
                  <TextField
                    control={register('Parent.enLname')}
                    label={t('pages.profile.sections.ParentInformation.form.fields.lastName')}
                    disabled={true}
                  />
                  <TextField
                    dir={'ltr'}
                    control={register('Parent.idNumber')}
                    label={t('pages.profile.sections.ParentInformation.form.fields.idNumber')}
                    disabled={true}
                  />
                </S.PasswordFormInputWrapper>
              </S.ProfileCard>
            )}

            <S.ProfileCard>
              <S.ProfileHead>
                <S.ProfileBoxTitle>{t('pages.profile.sections.securityDetails.title')}</S.ProfileBoxTitle>

                {disabledChangePassword ? (
                  <S.ProfileCardBtnNbgSvg
                    as={Button}
                    color="text-button"
                    iconStart={<EditIcon />}
                    onClick={() => setDisabledChangePassword(false)}
                  >
                    {t('pages.profile.sections.securityDetails.editCTA')}
                  </S.ProfileCardBtnNbgSvg>
                ) : (
                  <S.ParentCancleAndDef>
                    <S.ProfileCardBtnCancle
                      as={Button}
                      color="outlined"
                      type="button"
                      onClick={() => setDisabledChangePassword(true)}
                    >
                      {t('pages.profile.sections.securityDetails.form.cancelCTA')}
                    </S.ProfileCardBtnCancle>
                    <S.ProfileCardBtnchange
                      as={Button}
                      type="submit"
                      styleType="default"
                      onClick={() => handleSubmit(changePassword)()}
                    >
                      {t('pages.profile.sections.securityDetails.form.updateCTA')}
                    </S.ProfileCardBtnchange>
                  </S.ParentCancleAndDef>
                )}
              </S.ProfileHead>

              <Form>
                <S.PasswordFormInputWrapper>
                  <TextField
                    dir={'ltr'}
                    control={register('password')}
                    label={t('pages.profile.sections.securityDetails.form.fields.oldPassword')}
                    disabled={disabledChangePassword}
                  />
                  <TextField
                    dir={'ltr'}
                    control={register('newPassword')}
                    label={t('pages.profile.sections.securityDetails.form.fields.newPassword')}
                    disabled={disabledChangePassword}
                  />
                  <TextField
                    dir={'ltr'}
                    control={register('reEnterPassword')}
                    label={t('pages.profile.sections.securityDetails.form.fields.confirmPassword')}
                    disabled={disabledChangePassword}
                  />
                </S.PasswordFormInputWrapper>
              </Form>
            </S.ProfileCard>
          </>
        </S.Wrapper>
      )}
      <ModalVerifyCode
        loading={mobileVerifyLoading}
        open={showModalVerifyCode}
        onClose={() => closeVerifyCodeModal()}
        onSubmit={(code) => (activeUserInfoField === 'mobile' ? changePhone(code) : changeEmail(code))}
      />
    </WithSidebar>
  );
};

export default Profile;
